import { Fragment, useEffect } from "react";
import { Grid, Box, IconButton, CircularProgress } from "@mui/material";
import { Menu } from "@mui/icons-material";
import { Link, useSearchParams, useParams } from "react-router-dom";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

import { Steps } from "./Steps";
import NavbarLGImage from "../assets/navbar-lg-image.png";
import NavbarSMImage from "../assets/navbar-sm-image.png";
import { useOrganization } from "../store/organization";
import { useOrderDetail } from "../store/orderDetail";
import { redirectSkiptiCheckoutFlow } from "../helpers";
import { PARTNERS } from "../utils/constants";

export const Buffer = () => {
  //const params = useParams();
  const [searchParams] = useSearchParams();
  const clientParam = searchParams.get("client") || PARTNERS.HOME_DEPOT;

  const { getOrganization, organization } = useOrganization();
  const { updateFields } = useOrderDetail();

  useEffect(() => {
    initialLoad();
  }, []);

  const initialLoad = async () => {
    const zipParameter = searchParams.get("zip") || null;

    updateFields({
      zip: zipParameter,
      client: clientParam,
    });

    await loadOrganizationData(clientParam);
  };

  const loadOrganizationData = async (client) => {
    if (!client) {
      redirectSkiptiCheckoutFlow();
      return;
    }

    await getOrganization(client.toLowerCase());
  };

  return (
    <Grid container={true}>
      <Grid container={true} item={true}>
        <div
          id="top-bar"
          style={{
            backgroundColor: "#F05623",
            //   backgroundColor: "#332E2E",
            position: "fixed",
            top: "0px",
            width: "100%",
            padding: "3px 0",
            color: "white",
            textAlign: "center",
            zIndex: 1000,
          }}
        >
          <span
            style={{
              margin: "2px 0",
            }}
          >
            <LocalShippingIcon style={{ color: "white", marginRight: "6px" }} />
            New Experiences Delivered
          </span>
        </div>
      </Grid>

      <Grid container={true} item={true} style={{ marginTop: "28px" }}>
        <nav
          className="skipti-nav tw-h-20 tw-p-0 tw-m-0 tw-fixed tw-right-0 tw-left-0 tw-z-50 tw-bg-white tw-w-full"
          style={{
            top: "28px",
            backgroundColor: "#ffffff",
          }}
        >
          <div
            className="tw-h-full tw-flex tw-pr-0 tw-mx-auto tw-flex-wrap tw-justify-center"
            style={{ marginRight: "auto", marginLeft: "auto" }}
          >
            <div className="xl:tw-w-2/12 lg:tw-w-2/12 md:tw-w-3/12 sm:tw-w-2/12 tw-w-3/12 tw-pl-4 tw-pr-4 tw-h-full tw-items-center tw-flex">
              <Box sx={{ display: { xs: "none", md: "block" } }}>
                <Link
                  className="skipti-logo d-none d-md-block p-0"
                  to="/"
                  href="/"
                >
                  <img
                    src={NavbarLGImage}
                    alt=""
                    className="tw-h-10 tw-max-w-none"
                    style={{ zIndex: "2" }}
                  />
                </Link>
              </Box>

              <Box sx={{ display: { sm: "block", md: "none" } }}>
                <Link className="tw-block" to="/" href="/">
                  <img
                    src={NavbarSMImage}
                    className="tw-w-10 tw-h-10 tw-max-w-none"
                    alt=""
                  />
                </Link>
              </Box>
            </div>

            <div className="xl:tw-w-5/12 lg:tw-w-5/12 md:tw-w-6/12 sm:tw-w-7/12 tw-w-3/12 tw-text-base tw-justify-items-center tw-self-center">
              <span
                className="tw-text-skiptiOrange"
                style={{ marginRight: "12px" }}
              >
                Step 1
              </span>
              <span className="tw-text-verylightgrey">Schedule Your Order</span>
            </div>

            {/* <div className="xl:tw-w-5/12 lg:tw-w-5/12 md:tw-w-3/12 sm:tw-w-3/12 tw-w-6/12 tw-text-right tw-self-center sm:tw-pr-4 tw-justify-end tw-flex tw-items-center lg:tw-content-between ">
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={undefined}
                edge={false}
              >
                <Menu />
              </IconButton>
            </div> */}
          </div>

          <div
            className="progress thin d-lg-block"
            style={{ height: "7px", backgroundColor: "#ffffff" }}
          >
            <div
              className={"tw-bg-skiptiOrange progress-bar bg-color1"}
              role="progressbar"
              aria-valuenow={25}
              style={{
                width: `${25 || 0}%`,
                height: "7px",
              }}
              aria-valuemin="0"
              aria-valuemax="100"
            />
          </div>
        </nav>
      </Grid>

      {organization.isLoading ? (
        <div className="tw-my-32 tw-w-full tw-h-2/4 tw-flex tw-justify-center">
          <CircularProgress color="warning" size={40} />
        </div>
      ) : (
        organization.data && (
          <Fragment>
            <Grid
              container={true}
              item={true}
              style={{
                position: "relative",
                top: "85px",
                height: "calc(100vh - 85px)",
                backgroundImage: `url(${organization.data.backgroundImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "27% bottom",
                backgroundSize: "cover",
              }}
              className="tw-w-full"
            />

            <Steps />
          </Fragment>
        )
      )}
    </Grid>
  );
};
